var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M14 14H7v2h7v7h2v-7h7v-2h-7V7h-2v7zm16 .997C30 23.281 23.282 30 14.998 30 6.712 30 0 23.281 0 14.997 0 6.713 6.712 0 14.998 0 23.282 0 30 6.713 30 14.997z","fill":"#006DB6","fill-rule":"nonzero"}})}
var staticRenderFns = []

export { render, staticRenderFns }